import axios from 'axios';
import Container from '@mui/material/Container';
import Box from '@mui/material/Box';
import { Button, Typography } from '@mui/material';
import { grey } from '@mui/material/colors';
import React, { useState, useEffect } from 'react';

axios.defaults.withCredentials = true;
axios.defaults.timeout = 50000;

export default function App() {
  const [csrfToken, setCsrfToken] = useState<string | null>(null);
  const [certSha, setCertSha] = useState<string | null>(null);
  const [message, setMessage] = useState<string | null>(null);
  const [host, setHost] = useState<string>('');

  useEffect(() => {
    const fetchConfig = async () => {
      try {
        const response = await fetch('/config.json');
        const config = await response.json();
        setHost(config.host);
        console.log('Host loaded from config:', config.host);
        getCsrf(config.host);
      } catch (error) {
        console.error('Error loading config:', error);
      }
    };

    fetchConfig();
  }, []);

  const getCsrf = async (host: string) => {
    try {
      const response = await axios.get(`${host}/csfr/`);
      const token = response.data.csrfToken;
      setCsrfToken(token);
      console.log('CSRF Token:', token);
    } catch (error) {
      console.error('Error fetching CSRF token:', error);
    }
  };

  const changeDoorStatus = async (newStatus: string) => {
    if (!csrfToken) {
      console.error('No CSRF token available');
      return;
    }

    try {
      const response = await axios.put(
        `${host}/doorStatus/`,
        { newStatus: newStatus },
        {
          headers: {
            'X-CSRFToken': csrfToken,
            'Content-Type': 'application/json'
          }
        }
      );
      console.log('Door status response:', response.data);
    } catch (error) {
      console.error('Error sending door status:', error);
    }
  };

  const handleFirstButtonClick = async () => {
    setMessage(null);

    await changeDoorStatus('open');
    setMessage('Puerta abierta');
    setTimeout(() => {
      setMessage(null);
    }, 2000);
  };

  const handleSecondButtonClick = async () => {
    setMessage(null);

    await changeDoorStatus('closed');
    setMessage('Puerta cerrada');
    setTimeout(() => {
      setMessage(null);
    }, 2000);
  };

  return (
    <Container maxWidth="sm">
      <Box
        sx={{
          my: 4,
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          minHeight: '100vh',
        }}
      >
        <Button variant="contained" sx={{ mb: 2 }} onClick={handleFirstButtonClick}>
          Abrir puerta
        </Button>
        {message && (
          <Typography
            sx={{
              mb: 2,
              padding: '12px 16px',
              borderRadius: '8px',
              border: `1px solid ${grey[200]}`,
              backgroundColor: '#fff',
              boxShadow: `0px 4px 8px rgb(0 0 0 / 0.1)`,
              fontFamily: 'IBM Plex Sans, sans-serif',
              fontWeight: 500,
              fontSize: '0.875rem',
            }}
          >
            {message}
          </Typography>
        )}
        <Button variant="contained" onClick={handleSecondButtonClick}>
          Cerrar puerta
        </Button>
      </Box>
    </Container>
  );
}
